<script setup>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
defineProps({ activeUser: Object });
</script>

<template>
  <Header :activeUser="activeUser" />
  <v-main id="content">
    <slot />
  </v-main>
  <Footer />
</template>

<style scoped lang="scss">
#content {
  padding-top: 20px;

  @media (min-width: 960px) {
    padding-top: 40px;
  }
}
</style>
